(function () {
  'use strict';

  if (window.BigshockedSeamlessCarousel) {
    window.BigshockedSeamlessCarousel.initAll();
    return;
  }

  var ROOT_SELECTOR = '[data-bigshocked-seamless]';

  function modulo(value, length) {
    return ((value % length) + length) % length;
  }

  function removeCloneMetadata(clone) {
    var elements = [clone].concat(Array.from(clone.querySelectorAll('*')));

    elements.forEach(function (element) {
      element.removeAttribute('id');
      element.removeAttribute('data-shopify-editor-block');
      element.removeAttribute('data-shopify-block-id');
    });

    clone.setAttribute('data-bigshocked-clone', 'true');
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('tabindex');

    clone.querySelectorAll('a, button, input, select, textarea, summary, [tabindex]').forEach(function (element) {
      element.setAttribute('tabindex', '-1');
    });

    clone.querySelectorAll('.scroll-trigger').forEach(function (element) {
      element.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
      element.style.opacity = '1';
      element.style.transform = 'none';
    });

    return clone;
  }

  function SeamlessCarousel(root) {
    if (!root || root.dataset.bigshockedSeamlessBound === 'true') return;

    this.root = root;
    this.kind = root.dataset.bigshockedSeamless;
    this.track = root.querySelector('[data-bigshocked-seamless-track]');
    this.slideSelector = this.kind === 'slideshow' ? '.slideshow__slide' : '.collection-list__item';
    this.realSlides = this.track
      ? Array.from(this.track.querySelectorAll(this.slideSelector)).filter(function (slide) {
          return slide.getAttribute('data-bigshocked-clone') !== 'true';
        })
      : [];
    this.length = this.realSlides.length;
    this.prevButton = root.querySelector('button[name="previous"], .slider-button--prev');
    this.nextButton = root.querySelector('button[name="next"], .slider-button--next');
    this.counterCurrent = root.querySelector('.slider-counter--current');
    this.counterTotal = root.querySelector('.slider-counter--total');
    this.controlLinks = Array.from(root.querySelectorAll('.slider-counter__link'));
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.autoplayEnabled = this.track && this.track.getAttribute('data-autoplay') === 'true';
    this.autoplaySpeed = this.track ? Number(this.track.dataset.speed || 5) * 1000 : 5000;
    this.autoplayPaused = false;
    this.realIndex = 0;
    this.physicalIndex = this.length;
    this.animationTimer = null;
    this.autoplayTimer = null;
    this.pointerState = null;
    this.suppressClick = false;
    this.animating = false;

    if (!this.track || !this.length) return;

    root.dataset.bigshockedSeamlessBound = 'true';
    root.bigshockedSeamlessController = this;

    if (this.length === 1) {
      this.disableSingleSlideControls();
      this.updateUi();
      return;
    }

    this.buildClonedTrack();
    this.bindEvents();
    this.exposeComponentApi();

    var controller = this;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        controller.refresh(true);
        controller.play();
      });
    });
  }

  SeamlessCarousel.prototype.disableSingleSlideControls = function () {
    if (this.prevButton) this.prevButton.setAttribute('disabled', 'disabled');
    if (this.nextButton) this.nextButton.setAttribute('disabled', 'disabled');
  };

  SeamlessCarousel.prototype.buildClonedTrack = function () {
    var beforeFragment = document.createDocumentFragment();
    var afterFragment = document.createDocumentFragment();

    this.realSlides.forEach(function (slide) {
      beforeFragment.appendChild(removeCloneMetadata(slide.cloneNode(true)));
      afterFragment.appendChild(removeCloneMetadata(slide.cloneNode(true)));
    });

    this.track.insertBefore(beforeFragment, this.realSlides[0]);
    this.track.appendChild(afterFragment);
    this.allSlides = Array.from(this.track.querySelectorAll(this.slideSelector));
    this.track.classList.add('bigshocked-seamless-track');
  };

  SeamlessCarousel.prototype.bindEvents = function () {
    var controller = this;

    if (this.prevButton) {
      this.prevButton.addEventListener('click', function (event) {
        event.preventDefault();
        controller.moveBy(-1);
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        controller.moveBy(1);
      });
    }

    this.controlLinks.forEach(function (link, index) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        controller.moveToReal(index);
      });
    });

    this.track.addEventListener('pointerdown', function (event) {
      controller.onPointerDown(event);
    });
    this.track.addEventListener('pointermove', function (event) {
      controller.onPointerMove(event);
    });
    this.track.addEventListener('pointerup', function (event) {
      controller.onPointerEnd(event);
    });
    this.track.addEventListener('pointercancel', function (event) {
      controller.onPointerEnd(event);
    });
    this.track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
    this.track.addEventListener('scrollend', function () {
      if (controller.animating) controller.finishAnimation();
    });

    this.root.addEventListener(
      'click',
      function (event) {
        if (!controller.suppressClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        controller.suppressClick = false;
      },
      true
    );

    this.root.addEventListener('mouseenter', function () {
      controller.pause();
    });
    this.root.addEventListener('mouseleave', function () {
      controller.play();
    });
    this.root.addEventListener('focusin', function () {
      controller.pause();
    });
    this.root.addEventListener('focusout', function (event) {
      if (!controller.root.contains(event.relatedTarget)) controller.play();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        controller.pause();
      } else {
        controller.play();
      }
    });

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(function () {
        controller.queueRefresh();
      });
      this.resizeObserver.observe(this.track);
    } else {
      window.addEventListener('resize', function () {
        controller.queueRefresh();
      });
    }
  };

  SeamlessCarousel.prototype.exposeComponentApi = function () {
    var controller = this;

    this.root.slider = this.track;
    this.root.pause = function () {
      controller.pause();
    };
    this.root.play = function () {
      controller.play();
    };
    this.root.restartAutoplay = function () {
      controller.restartAutoplay();
    };
    this.root.autoplayButtonIsSetToPlay = this.autoplayEnabled;
  };

  SeamlessCarousel.prototype.queueRefresh = function () {
    var controller = this;
    if (this.refreshFrame) window.cancelAnimationFrame(this.refreshFrame);
    this.refreshFrame = window.requestAnimationFrame(function () {
      controller.refresh(true);
    });
  };

  SeamlessCarousel.prototype.refresh = function (instant) {
    if (!this.track.clientWidth || !this.allSlides.length) return;

    this.clearAnimationTimer();
    this.animating = false;
    this.physicalIndex = this.length + this.realIndex;
    this.scrollToPhysical(this.physicalIndex, instant !== false);
    this.updateUi();
  };

  SeamlessCarousel.prototype.getSlidePosition = function (physicalIndex) {
    var slide = this.allSlides[physicalIndex];
    if (!slide) return 0;

    if (this.kind === 'collection' && window.matchMedia('(max-width: 749px)').matches) {
      var position = slide.offsetLeft - (this.track.clientWidth - slide.offsetWidth) / 2;
      return Math.max(0, Math.min(position, this.track.scrollWidth - this.track.clientWidth));
    }

    return slide.offsetLeft;
  };

  SeamlessCarousel.prototype.scrollToPhysical = function (physicalIndex, instant) {
    var position = this.getSlidePosition(physicalIndex);
    var oldBehavior = this.track.style.scrollBehavior;

    if (instant || this.reducedMotion.matches) {
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollTo({ left: position, behavior: 'auto' });
      this.track.style.scrollBehavior = oldBehavior;
      return;
    }

    this.track.scrollTo({ left: position, behavior: 'smooth' });
  };

  SeamlessCarousel.prototype.moveBy = function (direction) {
    if (this.animating || !direction) return;
    this.pauseAutoplayTimer();
    this.animateToPhysical(this.physicalIndex + direction);
  };

  SeamlessCarousel.prototype.moveToReal = function (targetIndex) {
    if (this.animating || targetIndex === this.realIndex) return;

    var delta = targetIndex - this.realIndex;
    if (delta > this.length / 2) delta -= this.length;
    if (delta < -this.length / 2) delta += this.length;

    this.pauseAutoplayTimer();
    this.animateToPhysical(this.physicalIndex + delta);
  };

  SeamlessCarousel.prototype.animateToPhysical = function (targetPhysicalIndex) {
    var maxPhysicalIndex = this.allSlides.length - 1;
    this.physicalIndex = Math.max(0, Math.min(targetPhysicalIndex, maxPhysicalIndex));
    this.realIndex = modulo(this.physicalIndex - this.length, this.length);
    this.animating = true;
    this.updateUi();
    this.scrollToPhysical(this.physicalIndex, false);

    var controller = this;
    this.clearAnimationTimer();
    this.animationTimer = window.setTimeout(function () {
      controller.finishAnimation();
    }, this.reducedMotion.matches ? 20 : 520);
  };

  SeamlessCarousel.prototype.finishAnimation = function () {
    if (!this.animating) return;

    this.clearAnimationTimer();
    this.realIndex = modulo(this.physicalIndex - this.length, this.length);

    if (this.physicalIndex < this.length || this.physicalIndex >= this.length * 2) {
      this.physicalIndex = this.length + this.realIndex;
      this.scrollToPhysical(this.physicalIndex, true);
    }

    this.animating = false;
    this.track.style.scrollSnapType = '';
    this.updateUi();
    this.restartAutoplay();
  };

  SeamlessCarousel.prototype.clearAnimationTimer = function () {
    if (!this.animationTimer) return;
    window.clearTimeout(this.animationTimer);
    this.animationTimer = null;
  };

  SeamlessCarousel.prototype.onPointerDown = function (event) {
    if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
    if (event.target.closest('button, input, select, textarea, summary, .slideshow__controls, .slideshow__arrow')) return;
    if (this.animating) return;

    this.pauseAutoplayTimer();
    this.pointerState = {
      id: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      lastX: event.clientX,
      lastY: event.clientY,
      startScroll: this.track.scrollLeft,
      startPhysical: this.physicalIndex,
      startTime: Date.now(),
      axis: null
    };

  };

  SeamlessCarousel.prototype.onPointerMove = function (event) {
    var state = this.pointerState;
    if (!state || state.id !== event.pointerId) return;

    state.lastX = event.clientX;
    state.lastY = event.clientY;

    var deltaX = state.startX - state.lastX;
    var deltaY = state.startY - state.lastY;

    if (!state.axis) {
      if (Math.abs(deltaX) < 7 && Math.abs(deltaY) < 7) return;
      state.axis = Math.abs(deltaX) > Math.abs(deltaY) * 1.1 ? 'horizontal' : 'vertical';

      if (state.axis === 'vertical') return;

      this.suppressClick = true;
      this.track.style.scrollSnapType = 'none';
      this.track.style.cursor = 'grabbing';
      this.track.style.userSelect = 'none';

      if (this.track.setPointerCapture) {
        try {
          this.track.setPointerCapture(event.pointerId);
        } catch (error) {
          // Pointer capture can fail when a browser has already started vertical scrolling.
        }
      }
    }

    if (state.axis !== 'horizontal') return;

    event.preventDefault();
    this.track.scrollLeft = state.startScroll + deltaX;
  };

  SeamlessCarousel.prototype.onPointerEnd = function (event) {
    var state = this.pointerState;
    if (!state || state.id !== event.pointerId) return;

    state.lastX = event.clientX;
    state.lastY = event.clientY;
    this.pointerState = null;
    this.track.style.cursor = '';
    this.track.style.userSelect = '';

    if (state.axis !== 'horizontal') {
      this.track.style.scrollSnapType = '';
      this.restartAutoplay();
      return;
    }

    var deltaX = state.startX - state.lastX;
    var deltaY = state.startY - state.lastY;
    var duration = Math.max(1, Date.now() - state.startTime);
    var slide = this.allSlides[state.startPhysical];
    var slideWidth = slide ? slide.getBoundingClientRect().width : this.track.clientWidth;
    var distanceThreshold = Math.min(slideWidth * 0.1, 72);
    var quickSwipe = Math.abs(deltaX) >= 10 && Math.abs(deltaX) / duration >= 0.12;
    var horizontal = Math.abs(deltaX) > Math.abs(deltaY) * 1.05;
    var direction = 0;

    if (horizontal && (Math.abs(deltaX) >= distanceThreshold || quickSwipe)) {
      direction = deltaX > 0 ? 1 : -1;
    }

    this.physicalIndex = state.startPhysical;
    this.animateToPhysical(this.physicalIndex + direction);

    var controller = this;
    window.setTimeout(function () {
      controller.suppressClick = false;
    }, 120);
  };

  SeamlessCarousel.prototype.updateUi = function () {
    if (this.counterCurrent) this.counterCurrent.textContent = String(this.realIndex + 1);
    if (this.counterTotal) this.counterTotal.textContent = String(this.length);

    this.controlLinks.forEach(function (link, index) {
      var active = index === this.realIndex;
      link.classList.toggle('slider-counter__link--active', active);
      if (active) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    }, this);

    if (this.kind !== 'slideshow') return;

    this.realSlides.forEach(function (slide, index) {
      var active = index === this.realIndex;
      var links = slide.querySelectorAll('a');
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');

      if (active) {
        slide.removeAttribute('tabindex');
        links.forEach(function (link) {
          link.removeAttribute('tabindex');
        });
      } else {
        slide.setAttribute('tabindex', '-1');
        links.forEach(function (link) {
          link.setAttribute('tabindex', '-1');
        });
      }
    }, this);
  };

  SeamlessCarousel.prototype.pauseAutoplayTimer = function () {
    if (!this.autoplayTimer) return;
    window.clearTimeout(this.autoplayTimer);
    this.autoplayTimer = null;
  };

  SeamlessCarousel.prototype.pause = function () {
    this.autoplayPaused = true;
    this.pauseAutoplayTimer();
    if (this.track) this.track.setAttribute('aria-live', 'polite');
  };

  SeamlessCarousel.prototype.play = function () {
    if (!this.autoplayEnabled || document.hidden) return;
    this.autoplayPaused = false;
    if (this.track) this.track.setAttribute('aria-live', 'off');
    this.scheduleAutoplay();
  };

  SeamlessCarousel.prototype.restartAutoplay = function () {
    if (!this.autoplayEnabled || this.autoplayPaused || document.hidden) return;
    this.scheduleAutoplay();
  };

  SeamlessCarousel.prototype.scheduleAutoplay = function () {
    var controller = this;
    this.pauseAutoplayTimer();
    this.autoplayTimer = window.setTimeout(function () {
      if (!controller.animating) controller.moveBy(1);
    }, this.autoplaySpeed);
  };

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = [];

    if (context.matches && context.matches(ROOT_SELECTOR)) roots.push(context);
    roots = roots.concat(Array.from(context.querySelectorAll(ROOT_SELECTOR)));

    roots.forEach(function (root) {
      if (root.dataset.bigshockedSeamlessBound !== 'true') new SeamlessCarousel(root);
    });
  }

  window.BigshockedSeamlessCarousel = {
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
